import React, { Fragment } from "react";
import { PropTypes } from "prop-types";
import HtmlTooltip from "./HtmlTooltip";

export default function TransactionAddress({ type }) {
  return (
    <HtmlTooltip
      type={type}
      title={
        <Fragment>
          <p>
            <b>Transaction Address</b>
          </p>
          <p>
            Transaction addresses are used to represent the full address type in
            our system. It is structured as:
            <pre>
              <code>
                {`
{ 
  “company”: Company Name,
  “phone”: string,
  “email”: string,
  “addressName”: string,
  “addressType”: string,
  “address”: addressType
    {
      “line1”: string: Address Line 1,
      “line2”: string: Address Line 2,
      “line3”: string: Address Line 3,
      “line4”: string: Address Line 4,
      “line5”: string: Address Line 5,
      “city”: string,
      “stateProvince”: string,
      “postalCode”: string,
      “country”: string
    }
}
`}
              </code>
            </pre>
          </p>
        </Fragment>
      }
    ></HtmlTooltip>
  );
}
TransactionAddress.propTypes = {
  type: PropTypes.string.isRequired
};
